import EventEmitter from 'events'

export default class DebugObject extends EventEmitter {
  constructor() {
    super()
    this._debug = Object.keys(console)
      .filter(x => typeof console[x] === 'function')
      .reduce((acc, fn) => {
        acc[fn] = false
        return acc
      }, {})
    this.debug = {
      log: false,
      info: true,
      warn: true,
      error: true
    }
  }
  get debug() { return this._debug }
  set debug(next) {
    if (typeof next === 'boolean') {
      this._debug = Object.keys(this._debug).reduce((acc, x) => {
        acc[x] = next
        return acc
      }, {})
      return
    }
    if (typeof next !== 'object') return
    this._debug = {
      ...this._debug,
      ...(next || {})
    }
  }

  get dbg() {
    const CLASS = this.constructor.name
    return Object.keys(console).reduce((acc, fn) => {
      if (typeof console[fn] !== 'function') return acc
      acc[fn] = this._debug[fn]
        ? console[fn].bind(console, `[${fn.toUpperCase()}] <${CLASS}>`)
        : () => {}
      return acc
    }, {})
  }
}
